export const ArticleMetasConfig = {
  metaTitle: {
    suggestedLength: 60
  },
  metaDescription: {
    suggestedLength: 160
  }
};
